// Antd
import { notification as AntdNotification } from 'antd'

// Default Options
const defaultOptions = {
  duration: 10,
}

export const messageUtils_destroy = () => AntdNotification.destroy()

/**
 * @description Render success message toast
 *
 * @param {string} message
 * @param {any} config
 *
 * @return {any} any
 */
export const messageUtils_success = (message: string, config?: any): any => {
  return AntdNotification.success({
    message,
    ...defaultOptions,
    ...config,
  })
}

/**
 * @description Render warning message toast
 *
 * @param {string} message
 * @param {any} config
 *
 * @return {any} any
 */
export const messageUtils_warning = (message: string, config?: any): any => {
  return AntdNotification.warning({
    message,
    ...defaultOptions,
    ...config,
  })
}

/**
 * @description Render Error message toast
 *
 * @param {string} message
 * @param {any} config
 *
 * @return {any} any
 */
export const messageUtils_error = (message: string, config?: any): any => {
  return AntdNotification.error({
    message,
    ...defaultOptions,
    ...config,
  })
}
